import { Alert, Button, Field, Input } from '@persona/ui';
import { useState } from 'react';
import { adminApi, ApiError } from '../api';

/**
 * Вход в панель управления.
 *
 * Отдельный от клиентского: у сотрудников клуба почта и пароль, у клиентов —
 * телефон и код. Сообщение об ошибке одинаково для неизвестной почты
 * и неверного пароля, иначе по нему можно перебирать учётные записи.
 */
export function LoginPage({ onSuccess }: { onSuccess: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
  const [formError, setFormError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit(): Promise<void> {
    setFieldErrors({});
    setFormError(null);
    setSubmitting(true);

    try {
      await adminApi.login(email.trim(), password);
      onSuccess();
    } catch (error) {
      if (error instanceof ApiError) {
        if (error.fields) setFieldErrors(error.fields);
        else setFormError(error.message);
      } else {
        setFormError('Не удалось войти. Попробуйте ещё раз.');
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-dvh items-center justify-center px-4 py-10">
      <div className="w-full max-w-sm">
        <header className="mb-8 text-center">
          <p className="font-display text-lg font-semibold tracking-[0.2em] uppercase">PERSONA</p>
          <h1 className="mt-2 text-sm tracking-wide text-muted uppercase">Панель управления</h1>
        </header>

        {formError && <Alert tone="danger" className="mb-5">{formError}</Alert>}

        <form
          className="flex flex-col gap-5"
          onSubmit={(event) => {
            event.preventDefault();
            void submit();
          }}
          noValidate
        >
          <Field label="Электронная почта" error={fieldErrors.email} required>
            {({ id, describedBy, invalid }) => (
              <Input
                id={id}
                type="email"
                autoComplete="username"
                aria-describedby={describedBy}
                invalid={invalid}
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoFocus
              />
            )}
          </Field>

          <Field label="Пароль" error={fieldErrors.password} required>
            {({ id, describedBy, invalid }) => (
              <Input
                id={id}
                type="password"
                autoComplete="current-password"
                aria-describedby={describedBy}
                invalid={invalid}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            )}
          </Field>

          <Button type="submit" size="lg" fullWidth loading={submitting}>
            Войти
          </Button>
        </form>
      </div>
    </div>
  );
}
